export default __webpack_public_path__ + "static/media/index.8b6f1e8a.Scss";